import React from 'react'
import Subheader from '../../component/Subheader'
import AboutYear from './AboutYear'
import AboutEmotion from './AboutEmotion'
import AboutStatement from './AboutStatement'
import AboutEach from './AboutEach'
import AboutVideo from './AboutVideo'

export default function About() {

    const subheadData = {
      image: '../image/about-banner.webp',
      heading: 'Threads of Legacy Heritage Style Culture',
      pagename: 'About Us',
    }

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <AboutYear/>
    <AboutStatement/>
    <AboutVideo/>
    <AboutEmotion/>
    <AboutEach/>    
    </>
  )
}
